export const getResourceManagementConfigQueryKey = ()=>[
        'resource-management',
        'config'
    ];
